import { getNetworkErrorMessage } from '@framework/auth';
import { useTranslation } from '@framework/i18n';
import { INetworkErrorPage, NetworkErrorBodySwitch } from '@framework/ui';
import React from 'react';
import { AlertPageLayout } from '../components/AlertPageLayout';
import { getDefaultErrorTextFromStatus } from './getDefaultErrorMessageFromStatus';

export function NetworkAlertPage(props: INetworkErrorPage) {
  const { message, error, description, noLayout } = props;

  const { t } = useTranslation();
  const defaultText = getDefaultErrorTextFromStatus(t, error?.response?.status);

  const errorProps = {
    message: message ?? defaultText.message,
    title: defaultText.title,
    description: description ?? getNetworkErrorMessage(error ?? ''),
    status: error?.response?.status,
  };

  return (
    <AlertPageLayout noLayout={noLayout}>
      <NetworkErrorBodySwitch {...errorProps} />
    </AlertPageLayout>
  );
}
